// O formato da query string é DECISÃO DE PRODUTO, não detalhe do roteador.
//
// O serializador padrão do TanStack Router grava JSON na URL: um array vira
// `subjectId=%5B%22a%22%2C%22b%22%5D` e um número viaja como número. Aqui a
// URL é interface compartilhável ("padrão Gmail", TUT-122): `subjectId` REPETE
// na chave (`?subjectId=a&subjectId=b`), decidido pelo dono em 27/07, e todo
// valor é texto — é o contrato que favoritos e links colados em conversa já
// carregam. Trocar o roteador (TUT-177) não pode trocar o endereço.
//
// Por isso o roteador recebe este par: a mesma leitura/escrita que o
// `URLSearchParams` faz, com chave repetida virando array na leitura e array
// virando chave repetida na escrita. Tipagem fina (número, união fechada) é
// papel do `validateSearch` de cada rota, nunca daqui.

/** O que uma query string carrega: texto, ou textos repetidos na mesma chave. */
export type AppSearch = Record<string, string | string[]>;

export function parseAppSearch(searchStr: string): AppSearch {
  const params = new URLSearchParams(searchStr);
  const out: AppSearch = {};
  for (const key of new Set(params.keys())) {
    const all = params.getAll(key);
    out[key] = all.length > 1 ? all : all[0]!;
  }
  return out;
}

export function stringifyAppSearch(search: Record<string, unknown>): string {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(search)) {
    if (value === undefined || value === null) continue;
    for (const item of Array.isArray(value) ? value : [value]) {
      if (item === undefined || item === null) continue;
      params.append(key, String(item));
    }
  }
  const str = params.toString();
  return str ? `?${str}` : "";
}
